import PropTypes from 'prop-types';

/**
 * Call to Action Button
 * @param {{
 * type:"submit" | "button" | "reset",
 * children:string | JSX.Element,
 * variant: "main" | "secondary",
 * disabled?:boolean | undefined,
 * onClick?:React.MouseEventHandler<HTMLButtonElement>
 * cursorNotAllowed?:boolean
 * }} param0
 * @returns
 */
export default function ButtonCTA({
  type,
  children,
  variant,
  cursorNotAllowed,
  ...props
}) {
  const color = {
    main: ' bg-segments-accent-color-1 text-white',
    secondary: 'text-segments-accent-color-1',
  };

  return (
    <button
      type={type}
      aria-label={String(children)}
      className={`block h-segments-52px w-full text-base font-bold border focus:outline-none border-segments-accent-color-1 rounded-2xl ${
        color[variant]
      } disabled:opacity-50 ${cursorNotAllowed && 'cursor-not-allowed'}`}
      {...props}
    >
      {children}
    </button>
  );
}

ButtonCTA.propTypes = {
  type: PropTypes.oneOf(['submit', 'button', 'reset']).isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  variant: PropTypes.oneOf(['main', 'secondary']).isRequired,
  disabled: PropTypes.bool,
};
